import { useLocation } from 'react-router-dom';
import ReviewPage from '../../shared/booking/ReviewPage';
import { ExpiredSelection } from '../../shared/booking/FlowParts';
import { CHILD_FACTOR } from './data';
import PackageSummary from './PackageSummary';

export default function PackageReview() {
  const { state } = useLocation();
  if (!state?.summary) return <ExpiredSelection module="packages" />;

  const { summary, backTo } = state;
  const { adults, children, international, pricePerAdult } = summary;
  // Passport fields for international trips are added by ReviewPage.
  const specs = [
    ...Array.from({ length: adults }, (_, i) => ({ type: 'Adult', label: `Adult ${i + 1}`, fields: ['title', 'firstName', 'lastName', 'dob'] })),
    ...Array.from({ length: children }, (_, i) => ({ type: 'Child', label: `Child ${i + 1}`, note: '2–12 yrs', fields: ['title', 'firstName', 'lastName', 'dob'] })),
  ];
  const childPrice = summary.pricePerChild ?? Math.round(pricePerAdult * CHILD_FACTOR);
  const base = pricePerAdult * adults + childPrice * children;
  const gst = Math.round(base * 0.05);
  const lines = [
    [`Package cost — Adult × ${adults}`, pricePerAdult * adults],
    ...(children ? [[`Package cost — Child × ${children}`, childPrice * children]] : []),
    ['GST (5%)', gst, 'tax'],
    ...(international ? [['TCS (5%, refundable via ITR)', Math.round((base + gst) * 0.05), 'tcs']] : []),
  ];

  return (
    <ReviewPage
      module="packages"
      heading="Review your holiday"
      back={{ to: backTo, label: 'Change dates or travellers' }}
      summary={<PackageSummary summary={summary} />}
      info={[
        'Our holiday expert will call you within 24 hours to confirm hotels and personalise your itinerary.',
        international ? 'Passport must be valid for at least 6 months from the date of return.' : 'Carry a valid government photo ID for all travellers.',
        'Hotel names are indicative; similar category hotels may be provided.',
        'Cancellation: 10% charge if more than 30 days before departure, 50% for 15–30 days, non-refundable within 15 days.',
      ]}
      travellers={specs}
      international={international}
      travelDate={summary.date}
      travelEnd={summary.returnDate}
      fareLines={lines}
      buildBooking={() => ({
        title: summary.title,
        subtitle: `${summary.destination} · ${summary.nights}N/${summary.nights + 1}D · ${adults + children} traveller${adults + children > 1 ? 's' : ''}`,
        travelDate: summary.date,
        endDate: summary.returnDate,
        summary,
      })}
    />
  );
}
